import { defaultCommonState } from './module-common-state';

export default {
	resetState(state) {
		Object.assign(state, defaultCommonState);
	},
	updateFilterTaxPaper(state, res) {
		state.filterTaxPaper = res;
	},
	updateFilterDisplayTaxPaper(state, res) {
		state.filterDisplayTaxPaper = res;
	},
	updateOptionFilterTaxPaper(state, res) {
		state.optionsFilterTaxPaper = res;
	}
};
